// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2hZcM","active":"Loader_active__3nGTI"};